// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: vast.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "taf";
function createBaseVastAds() {
    return { ads: [] };
}
export const VastAds = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.ads) {
            VastAds_Ad.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.ads.push(VastAds_Ad.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { ads: globalThis.Array.isArray(object?.ads) ? object.ads.map((e) => VastAds_Ad.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.ads?.length) {
            obj.ads = message.ads.map((e) => VastAds_Ad.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return VastAds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds();
        message.ads = object.ads?.map((e) => VastAds_Ad.fromPartial(e)) || [];
        return message;
    },
};
function createBaseVastAds_Ad() {
    return { inLine: undefined };
}
export const VastAds_Ad = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.inLine !== undefined) {
            VastAds_Ad_Inline.encode(message.inLine, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_Ad();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.inLine = VastAds_Ad_Inline.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { inLine: isSet(object.inLine) ? VastAds_Ad_Inline.fromJSON(object.inLine) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.inLine !== undefined) {
            obj.inLine = VastAds_Ad_Inline.toJSON(message.inLine);
        }
        return obj;
    },
    create(base) {
        return VastAds_Ad.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_Ad();
        message.inLine = (object.inLine !== undefined && object.inLine !== null)
            ? VastAds_Ad_Inline.fromPartial(object.inLine)
            : undefined;
        return message;
    },
};
function createBaseVastAds_Ad_Inline() {
    return { creatives: [] };
}
export const VastAds_Ad_Inline = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.creatives) {
            VastAds_Creative.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_Ad_Inline();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.creatives.push(VastAds_Creative.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            creatives: globalThis.Array.isArray(object?.creatives)
                ? object.creatives.map((e) => VastAds_Creative.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.creatives?.length) {
            obj.creatives = message.creatives.map((e) => VastAds_Creative.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return VastAds_Ad_Inline.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_Ad_Inline();
        message.creatives = object.creatives?.map((e) => VastAds_Creative.fromPartial(e)) || [];
        return message;
    },
};
function createBaseVastAds_Creative() {
    return { id: "", linear: undefined, nonLinear: undefined };
}
export const VastAds_Creative = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.linear !== undefined) {
            VastAds_Creative_Linear.encode(message.linear, writer.uint32(18).fork()).ldelim();
        }
        if (message.nonLinear !== undefined) {
            VastAds_Creative_NonLinear.encode(message.nonLinear, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_Creative();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.linear = VastAds_Creative_Linear.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.nonLinear = VastAds_Creative_NonLinear.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            linear: isSet(object.linear) ? VastAds_Creative_Linear.fromJSON(object.linear) : undefined,
            nonLinear: isSet(object.nonLinear) ? VastAds_Creative_NonLinear.fromJSON(object.nonLinear) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.linear !== undefined) {
            obj.linear = VastAds_Creative_Linear.toJSON(message.linear);
        }
        if (message.nonLinear !== undefined) {
            obj.nonLinear = VastAds_Creative_NonLinear.toJSON(message.nonLinear);
        }
        return obj;
    },
    create(base) {
        return VastAds_Creative.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_Creative();
        message.id = object.id ?? "";
        message.linear = (object.linear !== undefined && object.linear !== null)
            ? VastAds_Creative_Linear.fromPartial(object.linear)
            : undefined;
        message.nonLinear = (object.nonLinear !== undefined && object.nonLinear !== null)
            ? VastAds_Creative_NonLinear.fromPartial(object.nonLinear)
            : undefined;
        return message;
    },
};
function createBaseVastAds_Creative_Linear() {
    return { durationMs: 0, mediaFiles: [] };
}
export const VastAds_Creative_Linear = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.durationMs !== 0) {
            writer.uint32(8).uint32(message.durationMs);
        }
        for (const v of message.mediaFiles) {
            VastAds_MediaFile.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_Creative_Linear();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.durationMs = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.mediaFiles.push(VastAds_MediaFile.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            durationMs: isSet(object.durationMs) ? globalThis.Number(object.durationMs) : 0,
            mediaFiles: globalThis.Array.isArray(object?.mediaFiles)
                ? object.mediaFiles.map((e) => VastAds_MediaFile.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.durationMs !== 0) {
            obj.durationMs = Math.round(message.durationMs);
        }
        if (message.mediaFiles?.length) {
            obj.mediaFiles = message.mediaFiles.map((e) => VastAds_MediaFile.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return VastAds_Creative_Linear.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_Creative_Linear();
        message.durationMs = object.durationMs ?? 0;
        message.mediaFiles = object.mediaFiles?.map((e) => VastAds_MediaFile.fromPartial(e)) || [];
        return message;
    },
};
function createBaseVastAds_Creative_NonLinear() {
    return { type: "", imageFile: undefined };
}
export const VastAds_Creative_NonLinear = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.imageFile !== undefined) {
            VastAds_ImageFile.encode(message.imageFile, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_Creative_NonLinear();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.imageFile = VastAds_ImageFile.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            imageFile: isSet(object.imageFile) ? VastAds_ImageFile.fromJSON(object.imageFile) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.imageFile !== undefined) {
            obj.imageFile = VastAds_ImageFile.toJSON(message.imageFile);
        }
        return obj;
    },
    create(base) {
        return VastAds_Creative_NonLinear.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_Creative_NonLinear();
        message.type = object.type ?? "";
        message.imageFile = (object.imageFile !== undefined && object.imageFile !== null)
            ? VastAds_ImageFile.fromPartial(object.imageFile)
            : undefined;
        return message;
    },
};
function createBaseVastAds_ImageFile() {
    return { width: 0, height: 0, maintainAspectRatio: false, sourceFile: "" };
}
export const VastAds_ImageFile = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.width !== 0) {
            writer.uint32(8).uint32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(16).uint32(message.height);
        }
        if (message.maintainAspectRatio !== false) {
            writer.uint32(24).bool(message.maintainAspectRatio);
        }
        if (message.sourceFile !== "") {
            writer.uint32(34).string(message.sourceFile);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_ImageFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.width = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.height = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.maintainAspectRatio = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sourceFile = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            maintainAspectRatio: isSet(object.maintainAspectRatio) ? globalThis.Boolean(object.maintainAspectRatio) : false,
            sourceFile: isSet(object.sourceFile) ? globalThis.String(object.sourceFile) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.maintainAspectRatio !== false) {
            obj.maintainAspectRatio = message.maintainAspectRatio;
        }
        if (message.sourceFile !== "") {
            obj.sourceFile = message.sourceFile;
        }
        return obj;
    },
    create(base) {
        return VastAds_ImageFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_ImageFile();
        message.width = object.width ?? 0;
        message.height = object.height ?? 0;
        message.maintainAspectRatio = object.maintainAspectRatio ?? false;
        message.sourceFile = object.sourceFile ?? "";
        return message;
    },
};
function createBaseVastAds_MediaFile() {
    return { delivery: "", type: "", width: 0, height: 0, bitrate: 0, sourceFile: "" };
}
export const VastAds_MediaFile = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.delivery !== "") {
            writer.uint32(18).string(message.delivery);
        }
        if (message.type !== "") {
            writer.uint32(26).string(message.type);
        }
        if (message.width !== 0) {
            writer.uint32(32).uint32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(40).uint32(message.height);
        }
        if (message.bitrate !== 0) {
            writer.uint32(48).uint32(message.bitrate);
        }
        if (message.sourceFile !== "") {
            writer.uint32(58).string(message.sourceFile);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastAds_MediaFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.delivery = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.width = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.height = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.bitrate = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.sourceFile = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            delivery: isSet(object.delivery) ? globalThis.String(object.delivery) : "",
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            bitrate: isSet(object.bitrate) ? globalThis.Number(object.bitrate) : 0,
            sourceFile: isSet(object.sourceFile) ? globalThis.String(object.sourceFile) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delivery !== "") {
            obj.delivery = message.delivery;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.bitrate !== 0) {
            obj.bitrate = Math.round(message.bitrate);
        }
        if (message.sourceFile !== "") {
            obj.sourceFile = message.sourceFile;
        }
        return obj;
    },
    create(base) {
        return VastAds_MediaFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastAds_MediaFile();
        message.delivery = object.delivery ?? "";
        message.type = object.type ?? "";
        message.width = object.width ?? 0;
        message.height = object.height ?? 0;
        message.bitrate = object.bitrate ?? 0;
        message.sourceFile = object.sourceFile ?? "";
        return message;
    },
};
function createBaseVastPlaylist() {
    return { preRollVastIds: [], midRolls: [] };
}
export const VastPlaylist = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.preRollVastIds) {
            writer.uint32(10).string(v);
        }
        for (const v of message.midRolls) {
            VastPlaylist_MidRoll.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastPlaylist();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.preRollVastIds.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.midRolls.push(VastPlaylist_MidRoll.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            preRollVastIds: globalThis.Array.isArray(object?.preRollVastIds)
                ? object.preRollVastIds.map((e) => globalThis.String(e))
                : [],
            midRolls: globalThis.Array.isArray(object?.midRolls)
                ? object.midRolls.map((e) => VastPlaylist_MidRoll.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.preRollVastIds?.length) {
            obj.preRollVastIds = message.preRollVastIds;
        }
        if (message.midRolls?.length) {
            obj.midRolls = message.midRolls.map((e) => VastPlaylist_MidRoll.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return VastPlaylist.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastPlaylist();
        message.preRollVastIds = object.preRollVastIds?.map((e) => e) || [];
        message.midRolls = object.midRolls?.map((e) => VastPlaylist_MidRoll.fromPartial(e)) || [];
        return message;
    },
};
function createBaseVastPlaylist_MidRoll() {
    return { offset: 0, vastId: "" };
}
export const VastPlaylist_MidRoll = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.offset !== 0) {
            writer.uint32(8).uint32(message.offset);
        }
        if (message.vastId !== "") {
            writer.uint32(18).string(message.vastId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVastPlaylist_MidRoll();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.offset = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.vastId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
            vastId: isSet(object.vastId) ? globalThis.String(object.vastId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.offset !== 0) {
            obj.offset = Math.round(message.offset);
        }
        if (message.vastId !== "") {
            obj.vastId = message.vastId;
        }
        return obj;
    },
    create(base) {
        return VastPlaylist_MidRoll.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVastPlaylist_MidRoll();
        message.offset = object.offset ?? 0;
        message.vastId = object.vastId ?? "";
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
